import { render } from "./PracticeTestPasteView.vue?vue&type=template&id=60a83676&scoped=true"
import script from "./PracticeTestPasteView.vue?vue&type=script&lang=js"
export * from "./PracticeTestPasteView.vue?vue&type=script&lang=js"

import "./PracticeTestPasteView.vue?vue&type=style&index=0&id=60a83676&scoped=true&lang=css"
import "./PracticeTestPasteView.vue?vue&type=style&index=1&id=60a83676&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a83676"]])

export default __exports__